import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs';
import { ApiUrlService } from '../../core/api-url.service';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-history-page',
  standalone: true,
  imports: [NgIf, NgFor, DatePipe],
  templateUrl: './history.page.html',
  styleUrl: './history.page.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HistoryPageComponent implements OnInit {
  purchases: PurchaseHistoryItem[] = [];
  errorMessage = '';
  successMessage = '';
  isLoading = false;
  isLoadingMore = false;
  limit = 50;
  hasMore = true;
  deletingId: number | null = null;

  constructor(
    private readonly http: HttpClient,
    private readonly apiUrl: ApiUrlService,
    private readonly cdr: ChangeDetectorRef,
    readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loadHistory(true);
  }

  loadHistory(reset: boolean): void {
    if (reset) {
      this.isLoading = true;
      this.hasMore = true;
      this.purchases = [];
    } else {
      this.isLoadingMore = true;
    }
    const offset = this.purchases.length;
    this.http
      .get<PurchaseHistoryResponse>(
        this.apiUrl.build(`/api/plateau/purchases/history?limit=${this.limit}&offset=${offset}`)
      )
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.isLoadingMore = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: response => {
          this.purchases = [...this.purchases, ...response.purchases];
          if (response.purchases.length < this.limit) {
            this.hasMore = false;
          }
          this.cdr.markForCheck();
        },
        error: () => {
          this.errorMessage = 'Impossible de charger l\'historique.';
          this.cdr.markForCheck();
        }
      });
  }

  cancelPurchase(item: PurchaseHistoryItem): void {
    if (!confirm(`Annuler l'achat de ${item.buyer.prenom} ${item.buyer.nom} ?`)) {
      return;
    }
    this.deletingId = item.id;
    this.errorMessage = '';
    this.successMessage = '';
    this.http
      .delete<void>(this.apiUrl.build(`/api/admin/purchases/${item.id}`))
      .pipe(
        finalize(() => {
          this.deletingId = null;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: () => {
          this.purchases = this.purchases.filter(p => p.id !== item.id);
          this.successMessage = 'Achat annulé avec succès.';
          this.cdr.markForCheck();
        },
        error: () => {
          this.errorMessage = 'Impossible d\'annuler cet achat.';
          this.cdr.markForCheck();
        }
      });
  }
}

interface PurchaseHistoryResponse {
  purchases: PurchaseHistoryItem[];
}

interface PurchaseHistoryItem {
  id: number;
  purchasedAt: string;
  buyer: {
    userId: number;
    prenom: string;
    nom: string;
    email: string;
  };
  commentaire: string | null;
}
